import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { TOP_UP_ROUTE_PATHS } from './config';

export const TOP_UP_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-top-up',
    path: TOP_UP_ROUTE_PATHS.topUp,
    component: lazy(() => import('./pages/top-up-page')),
    layout: 'default',
    permissions: { scopes: ['movements-top-up'] },
    menu: {
      title: 'Purchases',
    },
  },
];
